// TO-DO: homologate usage of enums for pump related unloadTypes
enum PumpCodes {
  PUMP = 'PUMP',
  OWN_PUMP = 'OWN_PUMP',
  BOOM_PUMP = 'PLACING_BOOM_PUMP',
  STATIONARY_PUMP = 'STATIONARY_PUMP',
  // Added for FR
  PUMPING_SERVICE = 'PUMPING_SERVICE',
}

enum CemexPumpCodes {
  PUMP = 'PUMP',
}

enum ExternalPumpCodes {
  PUMP = 'PUMP',
  BOOM_PUMP = 'PLACING_BOOM_PUMP',
  STATIONARY_PUMP = 'STATIONARY_PUMP',
  PUMPING_SERVICE = 'PUMPING_SERVICE',
}

export function isPump(value: string): boolean {
  const pumpCodes = Object.keys(PumpCodes).map(code => PumpCodes[code]);
  return pumpCodes.includes(value);
}

export function isCemexPump(value: string): boolean {
  const pumpCodes = Object.keys(CemexPumpCodes).map(code => PumpCodes[code]);
  return pumpCodes.includes(value);
}

export function isNotOwnPump(value: string): boolean {
  const pumpCodes = Object.keys(ExternalPumpCodes).map(code => ExternalPumpCodes[code]);
  return pumpCodes.includes(value);
}
